var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center",staticStyle:{"gap":"4px"}},_vm._l((_vm.statuses),function(s,i){return _c('span',{key:i,style:({
      backgroundColor: _vm.dotColor(s),
      width: '22px',
      height: '6px',
      borderRadius: '999px',
      display: 'inline-block',
    }),attrs:{"title":s}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }